// tslint:disable object-literal-key-quotes
export const ERROR_MESSAGES = {
  '40001': 'No se encontró un traspaso para los valores ingresados.',
  '40002': 'Verificación del captcha ha fallado.',
};
